import { Box } from "@mui/material";
import * as S from "./styles";
import { useDealer } from "@/contexts";

export type DealerInfoProps = {
  fullName?: string;
  company?: string;
  email?: string;
  textAlign?: string;
};
const DealerInfo: React.FC<DealerInfoProps> = ({
  fullName = undefined,
  company = undefined,
  email = undefined,
  textAlign = undefined,
}) => {
  const {dealer} = useDealer();
  return (
    <S.DealerInfoContainer $textAlign={textAlign}>
      <S.DealerInfoData>{fullName}</S.DealerInfoData>
      {/* <S.DealerInfoData>{company}</S.DealerInfoData> */}
      <S.DealerInfoData>{dealer?.company} {dealer?.dealerId}</S.DealerInfoData>
    </S.DealerInfoContainer>
  );
};

export default DealerInfo;
